import { reactive } from 'vue';
import api from 'dashboard/api/wahaManager';

const empty = () => ({ data: null, loading: false, error: '', updatedAt: 0 });
export const cache = reactive({
  owner: '',
  revision: 0,
  mode: 'new',
  selectedId: '',
  state: empty(),
  proxies: empty(),
  draft: { name: '', inbox_name: '', proxy_id: '' },
});
let generation = 0;
const pending = new Map();
export function resetCache(owner = '') {
  generation += 1;
  cache.revision = generation;
  for (const request of pending.values()) request.abort.abort();
  pending.clear();
  cache.owner = owner;
  cache.mode = 'new';
  cache.selectedId = '';
  cache.state = empty();
  cache.proxies = empty();
  cache.draft = { name: '', inbox_name: '', proxy_id: '' };
}
export function setOwner(owner) {
  if (cache.owner !== owner) resetCache(owner);
}
export function invalidate() {
  cache.state.updatedAt = 0;
  cache.proxies.updatedAt = 0;
}
export async function refresh(kind) {
  if (!cache.owner) return;
  if (pending.has(kind)) return pending.get(kind).promise;
  const version = generation;
  const slot = cache[kind];
  const abort = new AbortController();
  slot.loading = true;
  const promise = (async () => {
    try {
      const data = await api[kind]({ signal: abort.signal });
      if (version !== generation) return;
      if (data.account_id !== 1) throw new Error('账号范围不匹配');
      slot.data = data;
      slot.error = '';
      slot.updatedAt = Date.now();
    } catch (error) {
      if (version !== generation) return;
      if ([401, 403].includes(error.response?.status)) {
        const owner = cache.owner;
        resetCache(owner);
        cache[kind].error = '登录或管理权限已失效，请重新登录或联系管理员。';
      } else {
        slot.error =
          error.response?.data?.error || '刷新失败，当前显示上次数据。请重试。';
        slot.updatedAt = 0;
      }
    } finally {
      if (version === generation) {
        slot.loading = false;
        pending.delete(kind);
      }
    }
  })();
  pending.set(kind, { abort, promise });
  return promise;
}
